import axios from 'axios';

const local = process.env.NODE_ENV === 'development';

const channels = {
  'react-bug':
    'AAAAdMXrExc/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=U0s5amkIiVHpOAr419sZsfzStT3NRyu-vE6a1SFfQi8%3D',
  'apoio-comercial':
    'AAAATdrSB1U/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=mBQPmBA08aBNr7m8_485pb6IeTbMTwyoK3sOPDVatLs%3D',
};

export default async (text = '', channel: string): Promise<void> => {
  if (local) {
    console.log(text);
    return;
  }

  try {
    await axios.post(
      `https://chat.googleapis.com/v1/spaces/${channels[channel]}`,
      {
        text,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
  } catch (e) {
    console.log(e);
  }
};
